var windowWidth = window.innerWidth;

document.documentElement.style.setProperty('--100-vh-static', `${window.innerHeight}px`);
document.documentElement.style.setProperty('--vh-static', `${window.innerHeight * 0.01}px`);
document.documentElement.style.setProperty('--100-vh', `${window.innerHeight}px`);
document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);

window.addEventListener('resize', function() {
  if(window.innerWidth != windowWidth) {
    document.documentElement.style.setProperty('--100-vh-static', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--vh-static', `${window.innerHeight * 0.01}px`);
    windowWidth = window.innerWidth
  }
  document.documentElement.style.setProperty('--100-vh', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
})

window.headerHeight = Number(getComputedStyle(document.documentElement).getPropertyValue('--header-bar').replace('px', ''));